import {ChangeDetectorRef, Component, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractNumericInput} from "../abstract-numeric-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineNumericInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-numeric-input",
    styleUrls: ["./inline-numeric-input.component.scss"],
    templateUrl: "./inline-numeric-input.component.html"
})
export class FUIInlineNumericInputComponent extends FUIAbstractNumericInput {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}
